import { render, staticRenderFns } from "./CkImage.vue?vue&type=template&id=40aef354&scoped=true&"
import script from "./CkImage.vue?vue&type=script&lang=js&"
export * from "./CkImage.vue?vue&type=script&lang=js&"
import style0 from "./CkImage.vue?vue&type=style&index=0&id=40aef354&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40aef354",
  null
  
)

export default component.exports